import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import React, { useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { SecureRoute } from './components/navigation/SecureRoute';
import { AuthorizedPageLayout } from './pages/AuthorizedPageLayout';
import { LoggedInContextProvider } from './context/LoggedInContext';
import { UnitSelectionProvider } from './context/UnitSelectionContext';
import CustomLoginCallback from './CustomLoginCallback';

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
    scopes: [
        'openid',
        'profile',
        'authorities',
        'extendedProfile',
        'jobBidAdminADGroups',
    ],
});

function App() {
    const [impersonatedId, setImpersonatedId] = useState('');
    const [impersonatedIsAdmin, setImpersonatedIsAdmin] = useState(false);
    const navigate = useNavigate();
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        navigate(
            toRelativeUrl(
                originalUri || '/',
                process.env.REACT_APP_OKTA_REDIRECT_URI
            ),
            { replace: true }
        );
    };

    const impersonate = (impId, impIsAdmin) => {
        setImpersonatedId(impId);
        setImpersonatedIsAdmin(impIsAdmin);
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Routes>
                <Route
                    path="/*"
                    element={
                        <SecureRoute>
                            <UnitSelectionProvider>
                                <LoggedInContextProvider
                                    impersonatedId={impersonatedId}
                                    impersonatedIsAdmin={impersonatedIsAdmin}
                                >
                                    <AuthorizedPageLayout
                                        impersonateCallback={impersonate}
                                    />
                                </LoggedInContextProvider>
                            </UnitSelectionProvider>
                        </SecureRoute>
                    }
                />
                <Route path="/login" element={<CustomLoginCallback />} />
            </Routes>
        </Security>
    );
}

export default App;
